// StoreContext.jsx
import React from 'react';
import { LoadingProvider } from './LoadingContext';
import { ContentLayoutProvider } from './ContentLayout';
import { AuthProvider } from './AuthContext';

export function StoreProvider({ children }) {
  return (
    <LoadingProvider>
      <AuthProvider>
          {children}
      </AuthProvider>
    </LoadingProvider>
  );
}
